import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { CandidateJourney } from './candidate-journey.interface';

export const CANDIDATE_JOURNEY_INCLUDES = ['candidate', 'journey', 'status', 'modules', 'properties', 'journeyReferral'];

export class JourneyService {
   async getJourneys(candidateId: number, query: LocationQuery) {
      const response = await http.get<ApiResource<Array<CandidateJourney>>>(`/candidates/${candidateId}/journeys`, {
         params: { ...query },
      });
      return response.data;
   }

   async getJourney(candidateId: number, journeyId: number, query: LocationQuery) {
      const response = await http.get<ApiResource<CandidateJourney>>(`/candidates/${candidateId}/journeys/${journeyId}`, {
         params: { ...query },
      });
      return response.data;
   }

   async postJourney() {
      throw Error('Method not implemented');
   }

   async putJourney() {
      throw Error('Method not implemented');
   }

   async deleteJourney() {
      throw Error('Method not implemented');
   }
}
